export const STATUS_LABEL_ONLINE = 'Сервер в сети';
export const STATUS_LABEL_OFFLINE = 'Сервер недоступен';
export const STATUS_LABEL_FAILED = 'Нет связи с сервером';

export const STATUS_BAR_TITLE = 'Сервер';

export const STATUS_STAT_PLAYERS = 'Онлайн';
export const STATUS_STAT_MAP = 'Карта';
export const STATUS_STAT_STATE = 'Состояние';
export const STATUS_STATE_ONLINE = 'В сети';
export const STATUS_STATE_OFFLINE = 'Офлайн';
export const STATUS_MAP_UNKNOWN = '—';

export const STATUS_FILL_CAPTION = 'заполненность';
export const STATUS_FALLBACK_NAME = 'The Light of Empire';

export const STATUS_CONNECT_LABEL = 'Подключиться';
export const STATUS_CONNECT_SUB = 'Через Steam';

export const STATUS_PREVIEW_ALT = 'Скриншот сервера The Light of Empire';
export const STATUS_LIVE_LABEL = 'В реальном времени';
export const STATUS_PREVIEW_IMAGE = '/images/957e47872ed23bfa6d13a82d053b976f.jpg';

export const STATUS_ADDRESS_CAPTION = 'Адрес сервера';
export const STATUS_COPY_LABEL = 'Копировать';
export const STATUS_COPY_SUCCESS = 'Адрес сервера скопирован';
export const STATUS_COPY_FAILURE = 'Не удалось скопировать адрес — выделите и скопируйте вручную';

export const STATUS_ROSTER_CAPTION = 'Личный состав в сети';
export const STATUS_ROSTER_COL_NAME = 'Позывной';
export const STATUS_ROSTER_COL_TIME = 'В сети';
export const STATUS_ROSTER_EMPTY = 'Сейчас на сервере никого нет';
export const STATUS_ROSTER_MORE = 'Показать всех';
export const STATUS_ROSTER_LESS = 'Свернуть';

export const ROSTER_VISIBLE_LIMIT = 8;
